import React from 'react';
import { Descriptions } from 'antd';
import { FormInstance } from 'antd/es/form';
import CardView from '@/components/Card';
import Price from '@/components/Price';
import styles from '../style.less';
import { PreOrder } from '@/models/order';

type Props = {
  form: FormInstance;
  cards: PreOrder['cards'];
};

const CardTradeArea: React.FC<Props> = ({ form, cards }: Props) => {
  return (
    <div className={styles.item}>
      <Descriptions column={2} size={'small'} layout="vertical" bordered>
        <Descriptions.Item label="套餐卡购买" span={2}>
          {cards.map((card, index) => (
            <CardView key={`${card.id}-${index}`} card={card} />
          ))}
        </Descriptions.Item>
        <Descriptions.Item label="合计应收额" span={2}>
          <Price value={form.getFieldValue('actualPrice')} />
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default CardTradeArea;
